export default {
  employeeContractTypes: [],
  emptyEmployeeContractType: {},
  params: {
    entity: [],
    collection: []
  }
}